import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { usePopper } from "react-popper";

const Dropdown = (
  {
    placement = "bottom-end",
    offset = [0],
    btnClassName,
    button,
    options = [],
    onOptionSelect,
    children,
    onChange,
  },
  forwardedRef
) => {
  const [visibility, setVisibility] = useState(false);

  const referenceRef = useRef();
  const popperRef = useRef();

  const { styles, attributes } = usePopper(
    referenceRef.current,
    popperRef.current,
    {
      placement,
      modifiers: [
        {
          name: "offset",
          options: {
            offset,
          },
        },
      ],
    }
  );

  const handleDocumentClick = (event) => {
    if (
      referenceRef.current?.contains(event.target) ||
      popperRef.current?.contains(event.target)
    ) {
      return;
    }

    setVisibility(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, []);

  useImperativeHandle(forwardedRef, () => ({
    close() {
      setVisibility(false);
    },
  }));

  return (
    <>
      <button
        ref={referenceRef}
        onChange={onChange}
        type="button"
        className={btnClassName}
        onClick={() => setVisibility(!visibility)}
      >
        {button}
      </button>

      <div
        ref={popperRef}
        style={styles.popper}
        {...attributes.popper}
        className="z-50 max-h-[300px] overflow-y-scroll border-l-2 border-b-2"
        onClick={(e) => e.stopPropagation()}
      >
        {visibility && (
          <ul className="" style={{ minWidth: 'max-content' }}>
            {options.map((option) => (
              <li key={option.value}>
                <button
                  type="button"
                  onClick={() => {
                    onOptionSelect(option);
                    setVisibility(false);
                  }}
                >
                  {option.label}
                </button>
              </li>
            ))}
            {children}
          </ul>
        )}
      </div>
    </>
  );
};

export default forwardRef(Dropdown);
